var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-toast',{attrs:{"toaster":"b-toaster-top-center","id":"form-invalid-toast","no-close-button":"","variant":"warning"}},[_c('template',{slot:"default"},[_c('div',[_vm._v(" "+_vm._s(_vm.$t('toast.invalidInput'))+" ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }